<template>
    <div
        class="preview"
        :class="'preview--' + organisation.slug + ' preview--' + treeType"
        :style="cssVars"
    >
        <div class="preview__close" @click="togglePreview">
            <Icon>
                <IconClose />
            </Icon>
        </div>

        <div class="phone__wrapper" v-if="mergedTree">
            <div class="phone__phone">
                <div class="phone__phone__elements">
                    <span class="speaker"></span>
                    <span class="cam"></span>
                </div>
                <div class="phone__phone__screen">
                    <div
                        v-if="
                            (typeof $route.params.treeslug === 'undefined' &&
                                treeType === 'link') ||
                                (typeof $route.params.treeslug !==
                                    'undefined' &&
                                    mergedTree.type === 'link')
                        "
                        class="preview__phone__viewport"
                    >
                        <div
                            class="preview__phone__background"
                            :style="{
                                backgroundImage: backgroundImage
                                    ? `url(${backgroundImage})`
                                    : 'none',
                            }"
                        >
                            <div
                                v-if="mergedTree.background_overlay"
                                class="preview__phone__background__overlay"
                                :style="{
                                    background: mergedTree.background_color
                                        ? mergedTree.background_color
                                        : '#ffffff',
                                }"
                            ></div>
                        </div>

                        <div class="preview__phone__inner">
                            <div
                                class="preview__phone__scroll"
                                :class="{
                                    'preview__phone__scroll--nospace':
                                        mergedTree.logo_align_top,
                                }"
                            >
                                <div class="preview__phone__content">
                                    <!-- logo -->
                                    <div
                                        class="preview__phone__logo"
                                        :class="{
                                            circled:
                                                mergedTree.image_place ===
                                                'circle',
                                        }"
                                    >
                                        <img
                                            v-if="profileImage"
                                            :src="profileImage"
                                            alt=""
                                        />
                                    </div>
                                    <!-- highlighted -->
                                    <div
                                        class="preview__phone__section preview__phone__highlighted"
                                        v-if="
                                            highlightedLinks &&
                                                highlightedLinks.length > 0
                                        "
                                    >
                                        <div
                                            class="custom-css__highlight-links-wrapper"
                                        >
                                            <a
                                                v-for="link in highlightedLinks"
                                                :key="link.slug"
                                                :href="link.url"
                                                target="_blank"
                                                class="preview__phone__highlighted__link custom-css__highlight-link"
                                                :style="{
                                                    background: mergedTree.background_color_highlight
                                                        ? mergedTree.background_color_highlight
                                                        : '#1f1f1f',
                                                    color: mergedTree.text_color_1
                                                        ? mergedTree.text_color_1
                                                        : '#ffffff',
                                                }"
                                            >
                                                <span
                                                    v-html="
                                                        link.text
                                                            ? link.text
                                                            : link.short_name
                                                    "
                                                ></span>
                                                <Icon>
                                                    <IconChevronRight />
                                                </Icon>
                                            </a>
                                        </div>
                                    </div>
                                    <!-- linklist -->
                                    <div
                                        class="preview__phone__section preview__phone__list"
                                        v-if="
                                            normalLinks &&
                                                normalLinks.length > 0
                                        "
                                    >
                                        <div
                                            class="preview__phone__subtitle preview__phone__list__title custom-css__subtitle"
                                        >
                                            <span
                                                v-if="
                                                    mergedTree.title_linklist !=
                                                        null &&
                                                        mergedTree
                                                            .title_linklist
                                                            .length > 0
                                                "
                                                v-html="
                                                    mergedTree.title_linklist
                                                "
                                            ></span>
                                            <span v-else
                                                >Explore our world</span
                                            >
                                        </div>
                                        <div class="custom-css__links-wrapper">
                                            <a
                                                class="preview__phone__list__link custom-css__link"
                                                v-for="link in normalLinks"
                                                :key="link.slug"
                                                :href="link.url"
                                                target="_blank"
                                                :style="{
                                                    color: mergedTree.text_color_2
                                                        ? mergedTree.text_color_2
                                                        : '#000000',
                                                }"
                                            >
                                                <span
                                                    v-html="link.short_name"
                                                ></span>
                                                <Icon>
                                                    <IconChevronRight />
                                                </Icon>
                                            </a>
                                        </div>
                                    </div>
                                    <!-- social links -->
                                    <div
                                        class="preview__phone__section preview__phone__social"
                                        v-if="
                                            socialLinks &&
                                                socialLinks.length > 0
                                        "
                                    >
                                        <div
                                            class="preview__phone__subtitle custom-css__subtitle"
                                        >
                                            <span
                                                v-if="
                                                    mergedTree.title_sociallinks !=
                                                        null &&
                                                        mergedTree
                                                            .title_sociallinks
                                                            .length > 0
                                                "
                                                v-html="
                                                    mergedTree.title_sociallinks
                                                "
                                            ></span>
                                            <span v-else>Discover more</span>
                                        </div>
                                        <div
                                            class="preview__phone__social__links custom-css__social-links-wrapper"
                                        >
                                            <a
                                                :href="link.url"
                                                class="preview__phone__social__link custom-css__social-link"
                                                v-for="(link,
                                                index) in socialLinks"
                                                :key="index"
                                                target="_blank"
                                            >
                                                <Icon
                                                    v-if="
                                                        link.type.indexOf(
                                                            'social-custom',
                                                        ) < 0
                                                    "
                                                >
                                                    <IconSocial
                                                        :type="
                                                            link.type.split(
                                                                '-',
                                                            )[1]
                                                        "
                                                    />
                                                </Icon>
                                                <span
                                                    v-else
                                                    class="preview__phone__social__link preview__phone__social__link--custom"
                                                    v-html="link.image"
                                                >
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="preview__phone__imprint custom-css__imprint-wrapper"
                                    v-if="
                                        mergedTree.imprint &&
                                            mergedTree.imprint.length > 0
                                    "
                                    v-html="mergedTree.imprint"
                                ></div>

                                <!-- footer links -->
                                <div
                                    class="preview__phone__footer custom-css__footer"
                                    v-if="footerLinks && footerLinks.length > 0"
                                >
                                    <a
                                        class="preview__phone__footer__link custom-css__footer-link"
                                        :href="link.url"
                                        v-for="(link, index) in footerLinks"
                                        :key="index"
                                        target="_blank"
                                        v-html="link.short_name"
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <image-view
                        class="imageview__preview"
                        v-else-if="
                            (typeof $route.params.treeslug === 'undefined' &&
                                treeType === 'gallery') ||
                                (typeof $route.params.treeslug !==
                                    'undefined' &&
                                    mergedTree.type === 'gallery')
                        "
                    ></image-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import sanitizeHtml from 'sanitize-html';
import { mapGetters } from 'vuex';
import Icon from '@/components/Icon.vue';
import ImageView from '@/components/ImageView.vue';
import IconChevronRight from '@/components/icons/IconChevronRight.vue';
import IconSocial from '@/components/icons/IconSocial.vue';
import IconClose from '@/components/icons/IconClose.vue';

export default {
    components: {
        Icon,
        IconChevronRight,
        IconSocial,
        IconClose,
        ImageView,
    },
    computed: {
        ...mapGetters(['activeTree', 'manipulatedData', 'organisation']),
        mergedTree() {
            return { ...this.activeTree, ...this.manipulatedData };
        },
        treeType() {
            return this.mergedTree.type;
        },
        cssVars() {
            return {
                '--accentColor': this.mergedTree.accent_color,
                '--bgColor': this.mergedTree.background_color,
            };
        },
        profileImage() {
            if (this.mergedTree.image && this.mergedTree.image.url) {
                return this.mergedTree.image.url;
            }
            if (this.mergedTree.image && this.mergedTree.image.data) {
                return this.mergedTree.image.data.thumbnails.large;
            }
            return false;
        },
        backgroundImage() {
            if (
                this.mergedTree.background_image &&
                this.mergedTree.background_image.url
            ) {
                return this.mergedTree.background_image.url;
            }
            if (
                this.mergedTree.background_image &&
                this.mergedTree.background_image.data
            ) {
                return this.mergedTree.background_image.data.thumbnails.big;
            }
            return false;
        },
        highlightedLinks() {
            if (this.mergedTree.links && this.mergedTree.links.data) {
                const links = this.mergedTree.links.data.filter(l => {
                    return l.highlight && l.active && l.type === 'link';
                });
                return links.sort((a, b) => {
                    return a.position - b.position;
                });
            } else {
                return false;
            }
        },
        normalLinks() {
            if (this.mergedTree.links && this.mergedTree.links.data) {
                const links = this.mergedTree.links.data.filter(l => {
                    return !l.highlight && l.active && l.type === 'link';
                });
                return links.sort((a, b) => {
                    return a.position - b.position;
                });
            } else {
                return false;
            }
        },
        socialLinks() {
            if (this.mergedTree.links && this.mergedTree.links.data) {
                const links = this.mergedTree.links.data.filter(l => {
                    return l.active && l.type.includes('social-');
                });
                return links.sort((a, b) => {
                    return a.position - b.position;
                });
            } else {
                return false;
            }
        },
        footerLinks() {
            if (this.mergedTree.links && this.mergedTree.links.data) {
                const links = this.mergedTree.links.data.filter(l => {
                    return l.active && l.type === 'footer';
                });
                return links.sort((a, b) => {
                    return a.position - b.position;
                });
            } else {
                return false;
            }
        },
    },
    watch: {
        'mergedTree.css': {
            handler(newVal) {
                let newStyleEl = document.querySelector('#js-custom-style');
                let fonts = '';

                if (!newStyleEl) {
                    newStyleEl = document.createElement('style');
                    newStyleEl.setAttribute('type', 'text/css');
                    newStyleEl.setAttribute('id', 'js-custom-style');
                    document.head.appendChild(newStyleEl);
                }

                if (
                    this.organisation &&
                    this.organisation.fonts &&
                    this.organisation.fonts.data.length > 0
                ) {
                    this.organisation.fonts.data.forEach(f => {
                        let font_extension = f.path.split('.');
                        fonts +=
                            "@font-face{ font-family: '" +
                            f.target +
                            "'; src: url('/fonts/" +
                            f.path +
                            "') format('" +
                            font_extension[font_extension.length - 1] +
                            "'); font-weight: normal; font-style: normal; font-stretch: normal; }";
                    });
                }

                if (newVal !== '') {
                    newStyleEl.innerHTML = fonts + ' ' + sanitizeHtml(newVal);
                } else {
                    newStyleEl.innerHTML = fonts;
                }
            },
        },
    },
    mounted() {
        var fontcss_elements = document.querySelectorAll(
            '[data-class=fontcss]',
        );

        if (fontcss_elements.length > 0) {
            fontcss_elements[0].remove();
        }

        let fontcss = document.createElement('link');
        fontcss.rel = 'stylesheet';
        fontcss.href = '/css/' + this.organisation.slug + '.css';
        document.head.appendChild(fontcss);
        fontcss.dataset.class = 'fontcss';

        console.log(this.$route.params.treeslug, this.mergedTree);
    },
    methods: {
        togglePreview() {
            this.$emit('togglePreview');
        },
    },
};
</script>

<style lang="scss">
.preview {
    $block: &;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    font-family: 'Porsche Next', Akkurat, Helvetica, Arial, sans-serif;

    &--gallery {
        .phone__phone__screen {
            background: white;
        }
    }

    &--audi {
        font-family: 'AudiType-Extended', Akkurat, Helvetica, Arial, sans-serif;

        .preview {
            &__phone {
                &__subtitle {
                    font-size: 11px;
                }
                &__list {
                    &__link {
                        font-size: 13px;
                    }
                }
                &__highlighted {
                    &__link {
                        font-size: 15px;
                    }
                }
                &__footer {
                    &__link {
                        font-size: 10px;
                    }
                }
            }
        }
    }
    &--neutrogena,
    &--miele {
        font-family: miele;

        .preview {
            &__phone {
                &__subtitle {
                    font-size: 12px;
                }
                &__list {
                    &__link {
                        font-size: 15px;
                        font-weight: normal;
                    }
                }
                &__highlighted {
                    &__link {
                        font-weight: 700;
                        font-size: 15px;
                    }
                }
                &__footer {
                    &__link {
                        font-size: 11px;
                        padding: 10px;

                        &:before {
                            height: 18px !important;
                            opacity: 0.7;
                        }
                    }
                }
            }
        }
    }
    &--neutrogena {
        font-family: neutrogena;

        .preview {
            &__phone {
                &__list {
                    &__title {
                        color: white;
                        font-weight: 700;
                        border-color: rgba(255, 255, 255, 0.25);
                        letter-spacing: 0px;
                    }
                    &__link {
                        font-weight: 700;
                        letter-spacing: 0px;
                        line-height: 1.3;
                        border-color: rgba(255, 255, 255, 0.25);
                    }
                }
                &__subtitle {
                    color: white;
                    font-weight: 700;
                    letter-spacing: 0px;
                }
                &__highlighted {
                    &__link {
                        letter-spacing: 0px;
                    }
                }
                &__social {
                    &__link:not(:hover) {
                        svg {
                            g {
                                fill: white;
                            }
                        }
                    }
                }
                &__footer {
                    &__link {
                        color: black;
                        font-size: 13px;
                        font-weight: 600;

                        &:before {
                            display: none !important;
                        }
                    }
                }
            }
        }
    }
    &--bebe {
        .preview {
            &__phone {
                &__list {
                    &__title {
                        color: #da1984;
                        font-weight: 700;
                        letter-spacing: 0px;
                        border-color: rgba(255, 255, 255, 0.4);
                    }
                    &__link {
                        font-weight: normal;
                        letter-spacing: 0px;
                        line-height: 1.3;
                        border-color: rgba(255, 255, 255, 0.4);
                        font-size: 16px;
                    }
                }
                &__subtitle {
                    color: #da1984;
                    font-weight: 700;
                    letter-spacing: 0px;
                }
                &__highlighted {
                    &__link {
                        letter-spacing: 0px;
                        font-weight: normal;
                        font-size: 17px;
                    }
                }
                &__footer {
                    &__link {
                        color: black;
                        font-size: 13px;
                        font-weight: 600;

                        &:before {
                            display: none !important;
                        }
                    }
                }
            }
        }
    }
    &--tencel {
        font-family: circular;

        .preview {
            &__phone {
                &__list {
                    &__link {
                        letter-spacing: 0px;
                    }
                }
            }
        }
    }
    &--yuh {
        font-family: proxima_soft;

        .preview {
            &__phone {
                &__highlighted {
                    &__link {
                        font-weight: 700;
                        letter-spacing: 0;
                    }
                }
                &__list {
                    &__link {
                        letter-spacing: 0px;
                        font-weight: 600;
                        border-bottom-color: rgba(0, 0, 0, 0.1);
                    }
                }
                &__subtitle {
                    color: #fa5b35;
                    letter-spacing: 0;
                    font-weight: 700;
                    border-bottom-color: rgba(0, 0, 0, 0.1);
                }
            }
        }
    }
    &--reca_norm_de {
        font-family: opensans;

        .preview {
            &__phone {
                &__list {
                    &__link {
                        letter-spacing: 0px;
                        font-weight: 400;
                        font-size: 15px;
                    }
                }
                &__subtitle {
                    font-size: 12px;
                }
            }
        }
    }

    @include mq($until: tablet-landscape) {
        align-items: flex-start;
        padding: 0;
        overflow: auto;
    }

    &__close {
        position: absolute;
        top: 10px;
        right: 10px;
        height: 30px;
        width: 30px;
        z-index: 400;
        display: flex;
        align-items: center;
        justify-content: center;

        @include mq(tablet-landscape) {
            display: none;
        }
    }

    &__phone {
        max-width: 400px;
        width: 100%;
        padding: 3%;
        border-radius: 50px;
        background: $almost-black;
        letter-spacing: normal;

        @include mq($until: tablet-landscape) {
            max-width: 460px;
            padding: 0;
            border-radius: 0;
        }

        &__content {
            min-height: 570px;
        }
        &__imprint {
            position: relative;
            z-index: 90;
            font-family: arial;
            font-size: 12px;
            font-weight: normal;
            padding: 30px 40px;
            color: #666;
            letter-spacing: 0.02em;
            background: white;
            margin-top: 10px;

            a {
                text-decoration: underline;
                color: #000;
            }
            p {
                margin-bottom: 15px;
            }
            ul {
                margin-bottom: 15px;
                padding-left: 15px;

                li {
                    padding-left: 0px;
                    list-style-type: disc;
                }
            }
        }

        &__viewport {
            position: relative;
            height: 100%;
            width: 100%;
            border-radius: 40px;

            @include mq($until: tablet-landscape) {
                border-radius: 0;
            }

            @include mq(tablet-landscape) {
                height: 100%;
            }
        }

        &__inner {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            overflow: auto;
            border-radius: 40px;

            @include mq($until: tablet-landscape) {
                border-radius: 0;
                /* height: 100vh; */
                overflow: visible;
            }
        }

        &__scroll {
            position: relative;
            padding: 4% 0 0;
            min-height: 100%;
            display: flex;
            flex-direction: column;

            @include mq(tablet) {
                padding-top: 40px;
            }

            &--nospace {
                padding-top: 0;

                @include mq(tablet) {
                    padding-top: 28px;
                }
            }
        }

        &__background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;

            &__overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }

        &__section {
            padding: 0 25px;
            position: relative;
        }

        &__subtitle {
            font-size: 14px;
            font-weight: $font-weight-regular;
            color: $medium-light-grey;
        }

        &__logo {
            position: relative;
            height: 70px;
            width: 100%;
            margin: 0 auto 20px;

            img {
                @include object-fit(contain);
            }

            &.circled {
                width: 70px;
                border-radius: 100%;
                overflow: hidden;

                img {
                    @include object-fit;
                }
            }
        }

        &__highlighted {
            & + #{$block}__phone__social {
                padding-top: 25px;
            }

            &__link {
                display: block;
                position: relative;
                padding: 15px 70px 15px 30px;
                color: white;
                background: $almost-black;
                font-weight: $font-weight-bold;
                font-size: 18px;
                line-height: 1.3;

                &:before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 8px;
                    background: var(--accentColor, $red);
                }

                &:not(:last-child) {
                    margin-bottom: 10px;
                }

                // .no-touch &:hover {
                //     svg {
                //         transform: translate(5px, -50%);
                //     }
                // }

                svg {
                    position: absolute;
                    top: 50%;
                    right: 20px;
                    transform: translateY(-50%);
                    color: var(--accentColor, $red);
                    width: 1em;
                    height: 1em;
                    font-size: 32px;
                    transition: $link-transition;
                }
            }
        }

        &__list {
            padding: 25px 40px;

            &__title {
                padding-bottom: 12px;
                border-bottom: 2px solid $barely-white;
            }

            &__link {
                position: relative;
                display: block;
                font-weight: $font-weight-bold;
                font-size: 17px;
                border-bottom: 2px solid $barely-white;
                padding: 14px 28px 14px 0;
                box-sizing: border-box;
                line-height: 1.5;
                overflow: hidden;

                &:before,
                &:after {
                    content: '';
                    display: block;
                    width: 20px;
                    height: calc(100% + 4px);
                    position: absolute;
                    top: -2px;
                    background: $barely-white;
                    opacity: 0;
                    transition: $link-transition;
                }

                &:before {
                    right: 100%;
                }

                &:after {
                    left: 100%;
                }

                // .no-touch &:hover {
                //     background: $barely-white;

                //     &:before,
                //     &:after {
                //         opacity: 1;
                //     }

                //     svg {
                //         transform: translate(5px, -50%);
                //     }
                // }

                svg {
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                    color: var(--accentColor, $red);
                    width: 1em;
                    height: 1em;
                    font-size: 24px;
                    transition: $link-transition;
                }
            }
        }

        &__social {
            padding: 0 40px 20px;

            &__links {
                margin-top: 12px;
                display: flex;
                flex-wrap: wrap;
            }

            &__link {
                text-align: center;
                color: $almost-black;
                width: 20%;
                padding: 0 10px 5px;
                font-size: 24px;

                .no-touch &:hover {
                    color: var(--accentColor, $red);
                }

                &--custom {
                    svg {
                        width: 24px;
                        height: 24px;

                        * {
                            transition: all 0.25s ease;
                        }
                    }

                    &:hover {
                        * {
                            fill: var(--accentColor, $red);
                        }
                    }
                }
            }
        }

        &__footer {
            position: sticky;
            left: 0;
            bottom: 0;
            width: 100%;
            background: $light-grey;
            margin-top: auto;
            min-height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            padding: 10px 0;
            z-index: 100;

            @include mq($until: tablet-landscape) {
                max-width: 100vw;
                overflow: hidden;

                &:before,
                &:after {
                    content: '';
                    background: $light-grey;
                    position: absolute;
                    top: 0;
                    height: 100%;
                    width: 50vw;
                }

                &:before {
                    right: 100%;
                }

                &:after {
                    left: 100%;
                }
            }

            @include mq(tablet-landscape) {
                padding-bottom: 20px;
            }

            &__link {
                position: relative;
                display: block;
                color: $medium-light-grey;
                padding: 10px 15px;
                font-size: 12px;
                letter-spacing: 0.01em;
                font-weight: $font-weight-regular;
                transition: color 200ms $ease-out-quad;

                .no-touch &:hover {
                    color: $almost-black;
                }

                &:not(:last-child) {
                    &:before {
                        content: '';
                        display: block;
                        width: 1px;
                        height: 25px;
                        background: $medium-light-grey;
                        position: absolute;
                        top: 50%;
                        right: 0;
                        transform: translateY(-50%);
                    }
                }
            }
        }
    }
}

.phone {
    margin: 0 auto;
    max-width: 1000px;
    overflow: hidden;

    @media screen and (max-width: 1100px) {
        max-width: 850px;
    }

    &__wrapper {
        width: 350px;
        float: right;
        margin-top: 15px;

        @include mq($until: tablet-landscape) {
            margin-top: 20px;
        }

        @include mq($until: tablet) {
            width: 100%;
            margin: 0 auto;
            float: none;
        }
    }

    &__phone {
        width: 100%;
        padding-bottom: 200%;
        background: #111;
        border-radius: 50px;
        position: relative;

        @include mq($until: tablet) {
            padding-bottom: 0;
            height: 100vh;
        }

        &__screen {
            width: calc(100% - 18px);
            height: calc(100% - 18px);
            background: var(--bgColor, #111);
            position: absolute;
            top: 9px;
            left: 9px;
            border-radius: 41px;
            overflow: hidden;
            z-index: 5;

            @include mq($until: tablet) {
                width: 100%;
                height: 100%;
                border-radius: 0;
                top: 0;
                left: 0;
                overflow: auto;
            }
        }
        &__elements {
            @include mq($until: tablet) {
                display: none;
            }

            &:after {
                content: '';
                width: 50%;
                height: 4%;
                background: #111;
                position: absolute;
                left: 50%;
                top: 9px;
                transform: translateX(-50%);
                border-bottom-left-radius: 15px;
                border-bottom-right-radius: 15px;
                z-index: 20;
            }
            &:before {
                content: '';
                position: absolute;
                left: 50%;
                bottom: calc(1% + 9px);
                width: 37%;
                transform: translateX(-50%);
                background: #111;
                height: 4px;
                border-radius: 2px;
                z-index: 20;
            }

            .speaker {
                background: #333;
                position: absolute;
                left: 50%;
                top: 2.2%;
                transform: translateX(-50%);
                width: 15%;
                height: 1%;
                border-radius: 5px;
                z-index: 21;
            }
            .cam {
                background: #333;
                position: absolute;
                left: 60%;
                top: 2.2%;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                z-index: 21;

                @media screen and (max-width: 980px) {
                    width: 6px;
                    height: 6px;
                    top: 2.129%;
                }
            }
        }
    }
}
.imageview {
    &__preview {
        &.imageview__wrapper {
            margin-top: 35px;
            height: 647px;
            overflow-y: scroll;
            background: none !important;
        }
        .imageview {
            &__logo {
                left: calc(50% - 33px) !important;
                width: 66px !important;
                height: 66px !important;
            }
            &__newsletter {
                padding: 35px 15px !important;

                a {
                    font-size: 15px !important;
                }
            }
            &__imprint {
                padding: 50px 15px !important;
            }
        }
    }
}
</style>
